import React from 'react';
import { AuthLogic } from 'ha/modules/AuthLogic';
import Dialog from 'ha/components/next/Dialog';
import Authentication from 'ha/types/Authentication';
import LoginForm from 'ha/components/next/LoginForm';
import RegisterForm from 'ha/components/next/RegisterForm';
import { Box } from '@ha/dsl';
import { useIntl } from 'ha/i18n';
import { AuthType } from 'ha/modules/AuthLogic/types';
import { useMediaQuery } from 'ha/helpers/MediaQuery';
import { LOGIN, REGISTER } from 'ha/constants/pageNames';

interface Props {
  modalType: string;
  nextUrl: string;
  hideModal: () => void;
  showingModal: boolean;
  switchType: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  isAdvertiserRoute: boolean;
}

const AuthModal: React.FC<Props> = ({
  nextUrl,
  hideModal,
  showingModal,
  switchType,
  modalType,
  isAdvertiserRoute,
}) => {
  const { T } = useIntl();
  const isLoginForm = modalType === AuthType.login;
  const { sm } = useMediaQuery();

  return (
    <Dialog
      show={showingModal}
      maxWidth="xs"
      fullScreen={!sm}
      onClose={hideModal}
      name={isLoginForm ? LOGIN : REGISTER}
      title={
        isLoginForm
          ? T('Log in to your account')
          : T('Sign up for your account')
      }
      data-test-locator="Auth Dialog"
      content={
        isLoginForm ? (
          <AuthLogic>
            {(
              onLogin: Authentication['onLogin'],
              onRegister: Authentication['onRegister'],
              isLoading: Authentication['isLoading'],
            ) => (
              <Box mb={2}>
                <LoginForm
                  nextUrlProp={nextUrl}
                  onLogin={onLogin(nextUrl)}
                  isLoading={isLoading}
                  switchType={switchType}
                  isAdvertiserRoute={isAdvertiserRoute}
                />
              </Box>
            )}
          </AuthLogic>
        ) : (
          <AuthLogic>
            {(
              onLogin: Authentication['onLogin'],
              onRegister: Authentication['onRegister'],
              isLoading: Authentication['isLoading'],
            ) => (
              <Box mb={2}>
                <RegisterForm
                  nextUrlProp={nextUrl}
                  onRegister={onRegister(nextUrl)}
                  isLoading={isLoading}
                  switchType={switchType}
                  isAdvertiserRoute={isAdvertiserRoute}
                />
              </Box>
            )}
          </AuthLogic>
        )
      }
    />
  );
};

export default AuthModal;
